import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface HeaderSlotsTrackerReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useHeaderSlotsTracker = (): HeaderSlotsTrackerReturn => {
  const config = computed(() => [
    {
      id: 'shift control',
      text: 'Demo shift control',
      to: AppRoute.DemosSlotsTracker,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
